export default __webpack_public_path__ + "static/media/logo-hapvida-notredame.5918bf3a.png";